var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "spa-reservation-summary",
      class: { "--cancelled": _vm.isReservationCancelled },
    },
    [
      _c("h2", { staticClass: "spa-reservation-summary__title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.tc("spaSoft.reservationdetails.treatments")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spa-reservation-summary__guests" },
        _vm._l(
          _vm.reservationDetailsData.guestAvailabilities,
          function (guest, guestIndex) {
            return _c("SpaGuestTreatments", {
              key: guestIndex,
              attrs: {
                "guest-data": guest,
                "guest-number": Number(guestIndex) + 1,
              },
            })
          }
        ),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "spa-reservation-summary__footer" }, [
        _c(
          "div",
          { staticClass: "spa-reservation-summary__taxes" },
          [
            _c(
              _vm.isMobile ? "div" : "button",
              {
                tag: "component",
                staticClass: "spa-reservation-summary__taxes-button",
                on: {
                  click: function ($event) {
                    _vm.isTaxesExpanded = !_vm.isTaxesExpanded
                  },
                },
              },
              [
                _c(
                  "h4",
                  { staticClass: "spa-reservation-summary__taxes-title" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.tc("spaSoft.step2.stayDetailsTaxesAndFees")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "spa-reservation-summary__taxes-amount" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.getTotalTaxes({
                            formatted: true,
                            isReservation: true,
                          })
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.isMobile
                  ? _c("span", {
                      staticClass: "spa-reservation-summary__taxes-icon",
                      class: _vm.isTaxesExpanded ? "icon-minus" : "icon-add",
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "expand-y" } }, [
              _vm.isTaxesExpanded || _vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "spa-reservation-summary__taxes-details" },
                    _vm._l(
                      _vm.getTaxesList({ isReservation: true }),
                      function (taxItem, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "spa-reservation-summary__tax-list",
                          },
                          _vm._l(taxItem.taxes, function (tax, taxIndex) {
                            return _c(
                              "div",
                              {
                                key: taxIndex,
                                staticClass:
                                  "spa-reservation-summary__tax-item",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "spa-reservation-summary__tax-name",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(taxItem.treatmentName) +
                                        " - " +
                                        _vm._s(tax.name) +
                                        " - " +
                                        _vm._s(tax.rate) +
                                        "%\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "spa-reservation-summary__tax-amount",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getDisplayPrice({
                                            price: tax.total,
                                            withIsoCode: true,
                                            fromCurrency:
                                              _vm.reservationDetailsData
                                                .propertyData.currency.isoCode,
                                            toCurrency: _vm.orSelected(
                                              _vm.reservationDetailsData
                                                .propertyData.currency.isoCode
                                            ),
                                          })
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "spa-reservation-summary__total" }, [
          _c("h4", { staticClass: "spa-reservation-summary__total-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("spaSoft.step2.stayDetailsEstimatedCost")) +
                ":\n      "
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "spa-reservation-summary__total-amount" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.getTotalCost({ formatted: true, isReservation: true })
                ) +
                "\n      "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }